/**
 * Centralized runtime configuration.
 *
 * In production (behind Traefik), VITE_BACKEND_URL is left empty so that all
 * fetch / Socket.IO calls use relative URLs — the browser resolves them against
 * the current origin, making HTTP and HTTPS work transparently.
 *
 * In development, VITE_BACKEND_URL is set via docker-compose or .env to point
 * to the backend on a different port (e.g. http://localhost:4567).
 */

const env = import.meta.env.VITE_BACKEND_URL;

export const BACKEND_URL: string =
  env !== undefined && env !== ''
    ? env
    : import.meta.env.DEV
      ? 'http://localhost:4567'
      : '';
